// Copyright 2023, Durable
import React, { useCallback, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import useLocalStorageState from "use-local-storage-state";
import supportPages from "../routes/supportPages";
import { PageHeader } from "./PageHeader";
import { LocalStorageLocation } from "../LocalStorage";
import { route } from "../routes/userPages";

/**
 * A simple wrapper for dev tools. Wraps all non-manually-routed devtools,
 * automatically handling recent tools.
 */
function DevToolWrapper({ toolId }: { toolId: string }) {
  const [recentTools, setRecentTools] = useLocalStorageState<string[]>(
    LocalStorageLocation.RecentTools,
    {
      defaultValue: ["index_vis"]
    }
  );
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [icon, setIcon] = useState(<></>);
  const [foundTool, setFoundTool] = useState<route>(null);

  /**
   * Sets the passed in ID to the top of the recent tools array.
   */
  const setRecentDevtool = useCallback(
    (recentToolId: string) => {
      /**
       * Removes all objects with a given ID.
       */
      function removeObjectswithID(array: Array<any>, id: string) {
        array = array.filter((item) => {
          return item != id;
        });
        return array;
      }

      let newTools = recentTools;
      newTools = removeObjectswithID(newTools, recentToolId);
      newTools.unshift(recentToolId);
      // Only store the three most recent tools
      newTools = newTools.slice(0, 3);
      setRecentTools(newTools);
    },
    [recentTools, setRecentTools]
  );

  useEffect(() => {
    setFoundTool(supportPages.find((tool) => tool.id === toolId));
    if (foundTool != null) {
      if (!foundTool.routeOnly) {
        setRecentDevtool(toolId);
      }
      setTitle(foundTool.name);
      setDesc(foundTool.desc);
      setIcon(foundTool.icon);
    }
  }, [toolId, foundTool, setRecentDevtool]);
  return (
    <div className="devTool">
      <PageHeader
        visible={foundTool != null ? !foundTool.routeOnly : false}
        title={title}
        icon={icon}
        description={desc}
      />
      <Outlet />
    </div>
  );
}

export { DevToolWrapper };
